// extracted by mini-css-extract-plugin
export default {"title_wrapper":"PeriodsTitle_title_wrapper__BiuXb","wrapper":"PeriodsTitle_wrapper__Q-qqw","add_interval":"PeriodsTitle_add_interval__AUrTL","day":"PeriodsTitle_day__p9S+Q"};